import { Injectable } from "@angular/core";

import { CoreState } from "../state";

import { Market } from "./market.model";

/**
 * @deprecated [fabric-deprecated] - use startup context service from svc-config instead
 */
@Injectable({
	providedIn: "root",
})
export class MarketSelector {
	/**
	 * @deprecated [fabric-deprecated] - use startup context service from svc-config instead
	 */
	getCurrent() {
		return (state: CoreState): Market => state.market.currentMarket;
	}

	/**
	 * @deprecated [fabric-deprecated] - use startup context service from svc-config instead
	 */
	getLanguageCode() {
		return (state: CoreState): string => state.market.currentMarket.languageCode;
	}

	/**
	 * @deprecated [fabric-deprecated] - use startup context service from svc-config instead
	 */
	getAll() {
		return (state: CoreState): Market[] => state.market.markets;
	}
}
